import { formatDate, getDateByTimeZone } from "../utils/date";

export const DELIVERY_STATUS_0 = "DELIVERY_STATUS_RECEIPT";
export const DELIVERY_STATUS_1 = "DELIVERY_STATUS_PICKUP_SCHEDULED";
export const DELIVERY_STATUS_2 = "DELIVERY_STATUS_PICKUP_COMPLETED";
export const DELIVERY_STATUS_3 = "DELIVERY_STATUS_WAREHOUSED";
export const DELIVERY_STATUS_4 = "DELIVERY_STATUS_DELIVERY_STARTED";
export const DELIVERY_STATUS_5 = "DELIVERY_STATUS_DELIVERED";
export const DELIVERY_STATUS_6 = "DELIVERY_STATUS_DELIVERY_SENT_BACK";
export const DELIVERY_STATUS_7 = "DELIVERY_STATUS_DELIVERY_LOST";
export const DELIVERY_STATUS_8 = "DELIVERY_RIDER_ALLOCATED";

export const getPointToArray = (point) => {
  if (point && point.indexOf("POINT") > -1) {
    let pointArray = point.substring(6, point.length - 1).split(" ");

    return pointArray;
  } else {
    return [0, 0];
  }
};

export class Delivery {
  accidentAt = null;
  bookId = "";
  canceledAt = null;
  canceledReason = null;
  delayedDeliveries = [];
  deliveriesCountLeftYet = null;
  deliveryCompletedDate = null;
  deliveryRider = {};
  estimatedDeliveredAt = null;
  etc4 = "{}";
  isAccident = false;
  isCanceled = false;
  notReceivedImageLocation = null;
  order = null;
  pickupDateCompleted = null;
  pickupDateScheduled = null;
  pickupRider = {};
  postponedDate = null;
  receiptDate = null;
  receiverAddress = null;
  receiverAddressRoad = null;
  receiverMobile = "";
  receiverName = null;
  receiverPoint = null;
  releasedAt = null;
  senderName = null;
  sentBackDate = null;
  sentBackLogs = [];
  signImageLocation = null;
  status = null;
  time = null;
  tokenForPublicAPI = null;
  warehousedAt = null;
  lostDate = null;
  lostReason = null;

  constructor(delivery) {
    this.accidentAt = delivery.accidentAt;
    this.bookId = delivery.bookId;
    this.canceledAt = delivery.canceledAt;
    this.canceledReason = delivery.canceledReason;
    this.delayedDeliveries = delivery.delayedDeliveries;
    this.deliveriesCountLeftYet = delivery.deliveriesCountLeftYet;
    this.deliveryCompletedDate = delivery.deliveryCompletedDate;
    this.deliveryRider = delivery.deliveryRider;
    this.estimatedDeliveredAt = delivery.estimatedDeliveredAt;
    this.etc4 = delivery.etc4;
    this.isAccident = delivery.isAccident;
    this.isCanceled = delivery.isCanceled;
    this.notReceivedImageLocation = delivery.notReceivedImageLocation;
    this.order = delivery.order;
    this.pickupDateCompleted = delivery.pickupDateCompleted;
    this.pickupDateScheduled = delivery.pickupDateScheduled;
    this.pickupRider = delivery.pickupRider;
    this.postponedDate = delivery.postponedDate;
    this.receiptDate = delivery.receiptDate;
    this.receiverAddress = delivery.receiverAddress;
    this.receiverAddressRoad = delivery.receiverAddressRoad;
    this.receiverMobile = delivery.receiverMobile;
    this.receiverName = delivery.receiverName;
    this.receiverPoint = delivery.receiverPoint;
    this.releasedAt = delivery.releasedAt;
    this.senderName = delivery.senderName;
    this.sentBackDate = delivery.sentBackDate;
    this.sentBackLogs = delivery.sentBackLogs;
    this.signImageLocation = delivery.signImageLocation;
    this.status = delivery.status;
    this.time = delivery.time;
    this.tokenForPublicAPI = delivery.tokenForPublicAPI;
    this.warehousedAt = delivery.warehousedAt;
    this.lostDate = delivery.lostDate;
    this.lostReason = delivery.lostReason;
  }

  get completedLocation() {
    return this.deliveryEtc4Obj ? this.deliveryEtc4Obj.completedLocation : "";
  }

  get deliveryRiderName() {
    return this.deliveryRider ? this.deliveryRider.name : "두발히어로";
  }

  get deliveryEtc4Obj() {
    try {
      return this.etc4 && JSON.parse(this.etc4);
    } catch (e) {
      return {};
    }
  }

  get completedImage() {
    if (this.deliveryEtc4Obj.signImageLocation) {
      return this.deliveryEtc4Obj.signImageLocation;
    } else if (this.deliveryEtc4Obj.notReceivedImageLocation) {
      return this.deliveryEtc4Obj.notReceivedImageLocation;
    } else {
      return this.signImageLocation || this.notReceivedImageLocation;
    }
  }

  get receiverLnglat() {
    return {
      longitude: getPointToArray(this.receiverPoint)[0],
      latitude: getPointToArray(this.receiverPoint)[1],
    };
  }

  renderStatus() {
    switch (this.status) {
      case 0:
        return "접수";
      case 1:
        return "수거지정";
      case 2:
        return "수거완료";
      case 3:
        return "수거완료"; // 원래는 입고완료
      case 4:
        return "출고";
      case 5:
        return "배송완료";
      case 6:
        return "반송완료";
      case 7:
        return "분실완료";
      case 8:
        return "수거완료";
      // case 9:
      //   return "배송불가";
      // case 10:
      //   return "사고";
      // case 11:
      //   return "취소";
      case 12:
        return "연기";
      // case 14:
      //   return "배송인수인계";
      // case 15:
      //   return "간선하차";
      // case 16:
      //   return "배달대행 접수";
      // case 17:
      //   return "배달대행 접수 실패";
      // case 18:
      //   return "배달대행에서 취소";
      // case 19:
      //   return "배달대행에서 라이더 배차";
      // case 20:
      //   return "배달대행에서 라이더 배차 취소";
      default:
        return "";
    }
  }

  renderCanceledAt(dateFormat = "MM/dd HH:mm") {
    return (
      this.canceledAt &&
      formatDate(getDateByTimeZone(this.canceledAt), dateFormat)
    );
  }

  renderDeliveryCompletedDate(dateFormat = "HH:mm") {
    return (
      this.deliveryCompletedDate &&
      formatDate(getDateByTimeZone(this.deliveryCompletedDate), dateFormat)
    );
  }

  renderDeliveryLostDate(dateFormat = "HH:mm") {
    return (
      this.lostDate && formatDate(getDateByTimeZone(this.lostDate), dateFormat)
    );
  }

  renderPostponedDate(dateFormat = "HH:mm") {
    return (
      this.postponedDate &&
      formatDate(getDateByTimeZone(this.postponedDate), dateFormat)
    );
  }

  renderPickupDateScheduled(dateFormat = "HH:mm") {
    return (
      this.pickupDateScheduled &&
      formatDate(getDateByTimeZone(this.pickupDateScheduled), dateFormat)
    );
  }

  renderPickupDateCompleted(dateFormat = "HH:mm") {
    return (
      this.pickupDateCompleted &&
      formatDate(getDateByTimeZone(this.pickupDateCompleted), dateFormat)
    );
  }

  renderReceiptDate(dateFormat = "HH:mm") {
    return (
      this.receiptDate &&
      formatDate(getDateByTimeZone(this.receiptDate), dateFormat)
    );
  }

  renderReleasedAt(dateFormat = "HH:mm") {
    return (
      this.releasedAt &&
      formatDate(getDateByTimeZone(this.releasedAt), dateFormat)
    );
  }

  renderSentBackDate(dateFormat = "HH:mm") {
    return (
      this.sentBackDate &&
      formatDate(getDateByTimeZone(this.sentBackDate), dateFormat)
    );
  }

  renderWarehousedAt(dateFormat = "HH:mm") {
    return (
      this.warehousedAt &&
      formatDate(getDateByTimeZone(this.warehousedAt), dateFormat)
    );
  }
  renderDate() {
    switch (this.status) {
      case 0:
        return this.renderReceiptDate();
      case 1:
        return this.renderPickupDateScheduled();
      case 2:
      case 3:
      case 8:
        return this.renderPickupDateCompleted();
      case 4:
        return this.renderReleasedAt();
      case 5:
        return this.renderDeliveryCompletedDate();
      case 6:
        return this.renderSentBackDate();
      case 7:
        return this.renderDeliveryLostDate();
      case 12:
        return this.renderPostponedDate();
      default:
        return "";
    }
  }
}
